import React, { useEffect, useState } from "react";
import { ethers } from "ethers";
import { Card } from "react-bootstrap";
import toast from "react-hot-toast";
import { IoCopy } from "react-icons/io5";
import { copyToClipboard } from "../../../../Helper/Helper";
import trinitySharesArtifact from "../../../../configs/abis/trinity-shares.json";
import trinityManagerArtifact from "../../../../configs/abis/trinity-manager.json";
import config from "../../../../configs";

const { abi: trinitySharesAbi } = trinitySharesArtifact;
const { abi: trinityManagerAbi } = trinityManagerArtifact;
const MASTER_WALLET_ADDRESS = "0x6A80ea7885AF81CE11d87aCb004F1f301Abe247d";

const formatNumber = (value) => {
  if (value === null || value === undefined) return "--";
  return Number(value).toLocaleString();
};

const formatBnb = (value) => {
  if (!value && value !== 0) return "--";
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  return `${num.toLocaleString(undefined, {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  })} BNB`;
};

function SummaryCards({ sharesAddress, provider, refreshKey }) {
  const shortenAddress = (value) => {
    if (!value || typeof value !== "string") return "--";
    if (value.length <= 12) return value;
    return `${value.slice(0, 8)}...${value.slice(-8)}`;
  };

  const handleCopy = (value) => {
    if (!value) return;
    copyToClipboard(value);
  };

  const [stats, setStats] = useState({
    maxSupply: "--",
    totalMinted: "--",
    owner: "--",
    manager: "--",
    baseURI: "--",
    totalUsers: "--",
    purchaseTxCounter: "--",
    commissionTxCounter: "--",
    masterWalletBalance: "--",
  });
  const [loading, setLoading] = useState(false);
  const managerAddress = config.get("smartContract.TRINITY_MANAGER_ADDRESS");

  useEffect(() => {
    if (!sharesAddress || !provider || !managerAddress) return;

    let cancelled = false;
    const load = async () => {
      setLoading(true);
      try {
        const sharesContract = new ethers.Contract(
          sharesAddress,
          trinitySharesAbi,
          provider
        );
        const managerContract = new ethers.Contract(
          managerAddress,
          trinityManagerAbi,
          provider
        );
        const [
          maxSupply,
          totalMinted,
          owner,
          manager,
          totalUsers,
          purchaseTxCounterResult,
          commissionTxCounterResult,
          masterWalletBalanceWei,
        ] = await Promise.all([
          sharesContract.MAX_SUPPLY(),
          sharesContract.totalMinted(),
          sharesContract.owner(),
          sharesContract.manager(),
          managerContract.totalUsers(),
          managerContract.purchaseTxCounter(),
          managerContract.commissionTxCounter(),
          provider.getBalance(MASTER_WALLET_ADDRESS),
        ]);

        let baseURI = "--";
        if (typeof sharesContract.baseURI === "function") {
          try {
            const result = await sharesContract.baseURI();
            baseURI = result || "--";
          } catch (err) {
            console.warn("baseURI not available on shares contract", err);
          }
        }

        if (!cancelled) {
          setStats({
            maxSupply: maxSupply?.toString() || "0",
            totalMinted: totalMinted?.toString() || "0",
            owner,
            manager,
            baseURI,
            totalUsers: totalUsers?.toString() || "0",
            purchaseTxCounter: purchaseTxCounterResult?.toString() || "0",
            commissionTxCounter: commissionTxCounterResult?.toString() || "0",
            masterWalletBalance: ethers.utils.formatEther(
              masterWalletBalanceWei || 0
            ),
          });
        }
      } catch (error) {
        console.error("Failed to load summary", error);
        toast.error("Unable to fetch contract data");
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [sharesAddress, provider, refreshKey, managerAddress]);

  return (
    <Card className="bg-live contract-summary-card p-2">
      <Card.Body>
        {/* <div className="contract-summary-header">
          <div>
            <p className="contract-summary-eyebrow">On-chain snapshot</p>
            <h4>Contracts overview</h4>
          </div>
          <span
            className={`contract-summary-chip ${
              loading ? "chip-syncing" : "chip-live"
            }`}
          >
            {loading ? "Syncing..." : "Live"}
          </span>
        </div> */}

        <div className="contract-summary-sections row">
          <section className="contract-summary-panel col-md-5 py-1 px-3">
            <div className="contract-summary-panel-head">
              <div className="d-flex align-items-center justify-space-between w-100">
                <h5>TrinityShares Contract</h5>
                {/* <small>ERC-1155 token supply</small> */}
              </div>
              <div className="borderSpace borderSpaceTitle title-inbox "></div>
            </div>
            <div className="summary-stat-grid summary-grid">
              <div className="summary-cell">
                <p className="summary-label">Max Supply</p>
                <h3 className="summary-value">
                  {loading ? "Loading..." : formatNumber(stats.maxSupply)}
                </h3>
              </div>
              <div className="summary-cell">
                <p className="summary-label">Total Minted</p>
                <h3 className="summary-value">
                  {loading ? "Loading..." : formatNumber(stats.totalMinted)}
                </h3>
              </div>

              {/* <div className="summary-cell">
                <p className="summary-label">Master Wallet Balance</p>
                {loading ? (
                  <h3 className="summary-value">Loading...</h3>
                ) : (
                  <>
                    <p
                      className="summary-subtext"
                      style={{ marginBottom: "0", fontSize: "13px" }}
                    >
                      {formatBnb(stats.masterWalletBalance)}
                    </p>
                    <div className="summary-address-wrapper">
                      <span className="summary-value summary-address">
                        {shortenAddress(MASTER_WALLET_ADDRESS)}
                      </span>
                      <button
                        type="button"
                        className="summary-copy-btn"
                        onClick={() => handleCopy(MASTER_WALLET_ADDRESS)}
                      >
                        <IoCopy />
                      </button>
                    </div>
                  </>
                )}
              </div> */}

              {/* <div className="summary-cell">
                <p className="summary-label">Owner</p>
                {loading ? (
                  <h3 className="summary-value">Loading...</h3>
                ) : (
                  <div className="summary-address-wrapper">
                    <span className="summary-value summary-address">
                      {shortenAddress(stats.owner)}
                    </span>
                    <button
                      type="button"
                      className="summary-copy-btn"
                      onClick={() => handleCopy(stats.owner)}
                    >
                      <IoCopy />
                    </button>
                  </div>
                )}
              </div>
              <div className="summary-cell">
                <p className="summary-label">Manager Address</p>
                {loading ? (
                  <h3 className="summary-value">Loading...</h3>
                ) : (
                  <div className="summary-address-wrapper">
                    <span className="summary-value summary-address">
                      {shortenAddress(stats.manager)}
                    </span>
                    <button
                      type="button"
                      className="summary-copy-btn"
                      onClick={() => handleCopy(stats.manager)}
                    >
                      <IoCopy />
                    </button>
                  </div>
                )}
              </div> */}
            </div>
            {/* <div className="summary-baseuri">
              <p className="summary-label mb-1">Base URI</p>
              <code className="summary-code">
                {loading ? "Loading..." : stats.baseURI || "--"}
              </code>
            </div> */}
          </section>

          <section className="contract-summary-panel pl-5 col-md-7 py-1 px-3">
            <div className="contract-summary-panel-head">
              <div className="d-flex align-items-center justify-space-between w-100">
                <h5>TrinityManager Contract</h5>
                <small>Multisig metrics</small>
              </div>
              <div className="borderSpace borderSpaceTitle title-inbox "></div>
            </div>
            <div className="summary-stat-grid summary-grid">
              <div className="summary-cell">
                <p className="summary-label">Total Users</p>
                <h3 className="summary-value">
                  {loading ? "Loading..." : formatNumber(stats.totalUsers)}
                </h3>
              </div>
              <div className="summary-cell">
                <p className="summary-label">Purchase Transactions</p>
                <h3 className="summary-value">
                  {loading
                    ? "Loading..."
                    : formatNumber(stats.purchaseTxCounter)}
                </h3>
              </div>
              <div className="summary-cell">
                <p className="summary-label">Commission Transactions</p>
                <h3 className="summary-value">
                  {loading
                    ? "Loading..."
                    : formatNumber(stats.commissionTxCounter)}
                </h3>
              </div>
            </div>
          </section>
        </div>
      </Card.Body>
    </Card>
  );
}

export default SummaryCards;
